import React, { useState } from 'react';
import { Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../../api/auth';
import { setAuth } from '../../utils/auth';
import { L } from '../../styles/theme';
import AuthShell, { authLabelStyle } from './AuthShell';

const LoginPage: React.FC = () => {
  const [mode, setMode] = useState<'login' | 'forgot'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email.trim() || !password) {
      return message.warning('Введите почту и пароль');
    }
    setLoading(true);
    try {
      const { data } = await authApi.login(email.trim(), password);
      setAuth(data.access_token, data.user);
      navigate('/dashboard');
    } catch (e: any) {
      message.error(e.response?.data?.detail || 'Не удалось войти');
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async () => {
    if (!email.trim()) return message.warning('Введите почту');
    setLoading(true);
    try {
      await authApi.forgotPassword(email.trim());
      setSent(true);
    } catch (e: any) {
      message.error(e.response?.data?.detail || 'Не удалось отправить письмо');
    } finally {
      setLoading(false);
    }
  };

  if (mode === 'forgot') {
    return (
      <AuthShell footer="Вход только для сотрудников акимата Бурлинского района.">
        {sent ? (
          <>
            <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 6, color: L.ink }}>
              Проверьте почту
            </div>
            <div style={{ fontSize: 12.5, color: L.muted, lineHeight: 1.6 }}>
              Если <b style={{ color: L.text }}>{email.trim()}</b> заведена в системе, на неё
              отправлена ссылка для смены пароля. Ссылка действует час.
            </div>
            <Button
              block
              style={{ marginTop: 14 }}
              onClick={() => { setMode('login'); setSent(false); setPassword(''); }}
            >
              Вернуться ко входу
            </Button>
          </>
        ) : (
          <>
            <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 4, color: L.ink }}>
              Восстановление пароля
            </div>
            <div style={{ fontSize: 12, color: L.muted, marginBottom: 14, lineHeight: 1.5 }}>
              Пришлём ссылку для смены пароля на рабочую почту.
            </div>
            <span style={authLabelStyle}>Рабочая почта</span>
            <Input
              type="email"
              placeholder="name@aqsaiym.app"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onPressEnter={handleForgot}
              autoFocus
            />
            <Button type="primary" block loading={loading} onClick={handleForgot} style={{ marginTop: 12 }}>
              Прислать ссылку
            </Button>
            <Button
              type="text"
              block
              size="small"
              style={{ marginTop: 6, color: L.muted, fontSize: 12 }}
              onClick={() => setMode('login')}
            >
              Я вспомнил пароль
            </Button>
          </>
        )}
      </AuthShell>
    );
  }

  return (
    <AuthShell footer="Вход только для сотрудников акимата Бурлинского района.">
      <span style={authLabelStyle}>Рабочая почта</span>
      <Input
        type="email"
        placeholder="name@aqsaiym.app"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onPressEnter={handleLogin}
        autoFocus
        autoComplete="username"
      />

      <div style={{ display: 'flex', alignItems: 'baseline', marginTop: 12 }}>
        <span style={{ ...authLabelStyle, marginBottom: 5 }}>Пароль</span>
        <span
          onClick={() => setMode('forgot')}
          style={{ marginLeft: 'auto', fontSize: 11.5, color: L.accent, cursor: 'pointer' }}
        >
          Забыли пароль?
        </span>
      </div>
      <Input.Password
        placeholder="••••••••"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onPressEnter={handleLogin}
        autoComplete="current-password"
      />

      <Button type="primary" block loading={loading} onClick={handleLogin} style={{ marginTop: 14 }}>
        Войти
      </Button>
    </AuthShell>
  );
};

export default LoginPage;
